import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [트래픽 설정 > IP 그룹 설정] IP 그룹 목록 조회
   * @author jeee12
   * @return {[type]}        [description]
   */
  getIpGroupList(params) {
    return axios.post(`${baseUrl}/settings/flow/get-ip-group-list.do`, params);
  },
  /**
   * [트래픽 설정 > IP 그룹 설정] IP그룹에 속한 IP목록 조회
   * @author jeee12
   * @return {[type]}        [description]
   */
  getIpGroupIpList(params) {
    return axios.post(`${baseUrl}/settings/flow/get-ip-group-ip-list.do`, params);
  },
  /**
   * [트래픽 설정 > IP 그룹 설정] 특정 IP주소 / IP범위 / 서브넷 마스크에 맞는 IP주소 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getMatchedIpaddress(params) {
    return axios.post(`${baseUrl}/settings/flow/get-matched-ipaddress.do`, params);
  },
  /**
   * [트래픽 설정 > IP 그룹 설정] IP그룹 추가
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  addIpGroup(params) {
    return axios.post(`${baseUrl}/settings/flow/add-ip-group.do`, params);
  },
  /**
   * [트래픽 설정 > IP 그룹 설정] 선택한 IP 그룹 삭제
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteIpGroup(params) {
    return axios.post(`${baseUrl}/settings/flow/delete-ip-group.do`, params);
  },
  /**
   * [트래픽 설정 > IP 그룹 설정] 선택한 IP 그룹 수정
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateIpGroup(params) {
    return axios.post(`${baseUrl}/settings/flow/update-ip-group.do`, params);
  },
  /**
   * [트래픽 설정 > 인터페이스 그룹 설정] 인터페이스 그룹 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getInterfaceGroupList(params) {
    return axios.post(`${baseUrl}/settings/flow/get-interface-group-list.do`, params);
  },
  /**
   * [트래픽 설정 > 인터페이스 그룹 설정] 인터페이스 그룹에 속한 인터페이스 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getInterfaceGroupInterfaceList(params) {
    return axios.post(`${baseUrl}/settings/flow/get-interface-group-interface-list.do`, params);
  },
  /**
   * [트래픽 설정 > 인터페이스 그룹 설정] 인터페이스 관리대상 전체 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getInterfaceList(params) {
    return axios.post(`${baseUrl}/settings/flow/get-interface-list.do`, params);
  },
  /**
   * [트래픽 설정 > 인터페이스 그룹 설정] 인터페이스 그룹 추가
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  addInterfaceGroup(params) {
    return axios.post(`${baseUrl}/settings/flow/add-interface-group.do`, params);
  },
  /**
   * [트래픽 설정 > 인터페이스 그룹 설정] 선택한 인터페이스 그룹 삭제
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteInterfaceGroup(params) {
    return axios.post(`${baseUrl}/settings/flow/delete-interface-group.do`, params);
  },
  /**
   * [트래픽 설정 > 인터페이스 그룹 설정] 선택한 인터페이스 그룹 수정
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateInterfaceGroup(params) {
    return axios.post(`${baseUrl}/settings/flow/update-interface-group.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/netdevice/traffic-settings.js